import type { ChiTietHoaDonBanHangDichVu } from '@/types/schemas';

export function calcUtils(detailItems: BanHangRecord[] = []) {
  const tong_tien = detailItems.reduce((sum, item) => {
    const tien_nt2 = Math.round(Number(item.tien_nt2) * 10) / 10;
    const ck_nt = Math.round(Number(item.ck_nt) * 10) / 10;
    return sum + tien_nt2 - ck_nt;
  }, 0);
  const thue = Math.round(detailItems.reduce((sum, item) => sum + (Number(item.thue_nt) || 0), 0) * 10) / 10;
  const tong_ck = Math.round(detailItems.reduce((sum, item) => sum + (Number(item.ck_nt) || 0), 0) * 10) / 10;
  const tong_thanh_toan = Number(tong_tien + thue);

  return {
    tong_tien,
    thue,
    tong_ck,
    tong_thanh_toan
  };
}

export const handleUpdateRowFields = (
  row: ChiTietHoaDonBanHangDichVu,
  field: string,
  newValue: BanHangValue
): Partial<ChiTietHoaDonBanHangDichVu> => {
  if (field === 'so_luong' || field === 'gia_nt2' || field === 'tl_ck' || field === 'ma_thue_data') {
    const so_luong = field === 'so_luong' ? newValue : row.so_luong;
    const gia_nt2 = field === 'gia_nt2' ? newValue : row.gia_nt2;
    const tl_ck = field === 'tl_ck' ? newValue : row.tl_ck;
    const thue_suat = field === 'ma_thue_data' ? newValue?.thue_suat || 0 : row.ma_thue_data?.thue_suat || 0;

    const tien_nt2 = (Number(so_luong) || 0) * (Number(gia_nt2) || 0);
    const ck_nt = (tien_nt2 * (Number(tl_ck) || 0)) / 100;
    const thue_nt = ((tien_nt2 - ck_nt) * (Number(thue_suat) || 0)) / 100;

    return {
      tien_nt2,
      ck_nt,
      thue_nt
    };
  }
  return {};
};
